import React from "react";
import { Link } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";

import Icon from "components/Icon";
import PropTypes from "prop-types";
import CancelGame from "./CancelGame";
import { toast } from "react-toastify";
import { gameTypeTypes } from "domain/Directories/types";

const GameControls = ({
    id,
    isOrganizer,
    gameLink,
    privateCode,
    gameType,
    isTraining,
}) => {
    const showCopiedMessage = () => {
        toast.info("Ссылка на игру скопирована!");
    };

    let editUrl = `/editGame/${id}`;
    if (privateCode) {
        editUrl += `?code=${privateCode}`;
    }

    return (
        <div className="game-controls">
            <CopyToClipboard
                text={document.location.origin + gameLink}
                onCopy={showCopiedMessage}
            >
                <button className="btn" type="button">
                    <Icon type="export" inheritColor />
                    <span className="hide-desktop-down">
                        Поделиться {isTraining ? "тренировкой" : "игрой"}
                    </span>
                </button>
            </CopyToClipboard>

            {isOrganizer && (
                <>
                    <Link to={editUrl} className="icon-container">
                        <Icon type="edit" inheritColor />
                        <span className="hide-desktop-down">
                            Редактировать {isTraining ? "тренировку" : "игру"}
                        </span>
                    </Link>
                    <CancelGame
                        id={id}
                        gameType={gameType}
                        isTraining={isTraining}
                    />
                </>
            )}
        </div>
    );
};

GameControls.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    privateCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    isOrganizer: PropTypes.bool,
    gameLink: PropTypes.string.isRequired,
    gameType: gameTypeTypes,
    isTraining: PropTypes.bool,
};

export default GameControls;
